import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { featureName } from './types';
import { EffectsModule } from '@ngrx/effects';
import { CartEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(featureName, reducers), EffectsModule.forFeature([CartEffects])]
})
export class CartModule {}
